export type ShopType = 'all' | 'apparel' | 'salon'

export type ShopTypeId = 0 | 1 | 2

export const shopTypeToIdMap: Record<ShopType, ShopTypeId> = {
  all: 0,
  apparel: 1,
  salon: 2,
}

export const getShopTypeLabelFromShopType = (shopType: ShopType) => {
  switch (shopType) {
    case 'all':
      return 'ALL'
    case 'apparel':
      return 'アパレル'
    case 'salon':
      return '美容室'
  }
}
